import { render, staticRenderFns } from "./OrderItemFees.vue?vue&type=template&id=06340632"
import script from "./OrderItemFees.vue?vue&type=script&lang=js"
export * from "./OrderItemFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports